import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Colors, getSpacing, ItemCard, ListEmpty, Picker, Rating, Text, TextView } from '@rahtab/ui';
import { ListScreen } from '@rahtab/stack-navigator';
import OrderItem from './OrderItem';
import useOrdersHistory from '../../hooks/useOrdersHistory';
import { RouteProp } from '@react-navigation/core';
import { RootStackType } from '../../Router';
import SortIcon from '@rahtab/ui/dist/icons/SortIcon';
import useMerchandise from 'hooks/useOrderingMerchandise';

const defaultMerchandise = require('../../../assets/images/defaultMerchandise.png');

const OrdersHistory: React.VFC<OrdersHistoryProps> = ({ route }) => {
  const [activeSort, setActiveSort] = useState('newest');
  const { merchandiseId } = route.params;
  const { data: merchandise } = useMerchandise(merchandiseId);
  const { data, refetch, loading, called, fetchMore } = useOrdersHistory({ merchandiseId });
  return (
    <ListScreen
      title="سوابق سفارشات"
      loading={!called && loading}
      data={merchandise}
      refreshing={called && loading}
      onRefresh={refetch}
      onEndReached={() => (data ? fetchMore() : undefined)}
      renderControls={({ name, imageUrl }) => {
        return (
          <>
            <ItemCard title={name} image={imageUrl} inHeader hasChevron={false} defaultImage={defaultMerchandise}>
              <Text color="description">
                تعداد سفارشات وصول نشده: <Text variant="cardTitle">{data.notReceivedCount}</Text>
              </Text>
              <Rating value={0} count={parseFloat(data.rateCount || '0')} />
            </ItemCard>
            <View style={styles.controlsContainer}>
              <Picker
                selectedValue={activeSort}
                color="primary"
                variant="outlined"
                onSelectValue={setActiveSort}
                marginBottom={0}
                customIcon={<SortIcon fill={Colors.primary} />}
                style={styles.sort}>
                <Picker.Item label="جدیدترین" value="newest" />
              </Picker>
            </View>
          </>
        );
      }}
      listData={data.data}
      keyExtractor={(_, index) => `orders-${index}`}
      ListEmptyComponent={<ListEmpty text="سفارشی یافت نشد." />}
      renderItem={({ item }) => {
        return <OrderItem {...item} />;
      }}
    />
  );
};

export default OrdersHistory;

const styles = StyleSheet.create({
  controlsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: getSpacing(),
  },
  numberOfOrdersTextView: {
    flex: 1,
  },
  sort: {
    flex: 2,
    backgroundColor: Colors.card,
    borderColor: Colors.primary,
  },
});

interface OrdersHistoryProps {
  route: RouteProp<RootStackType, 'OrdersHistory'>;
}
